import React from "react";
import PropTypes from "prop-types";

const DropdownOption = ({ value, selectOption }) => {
  const handleSelectOption = () => {
    selectOption(value);
  };

  return (
    <li className="dropdown__option" onClick={handleSelectOption}>
      {value}
    </li>
  );
};

DropdownOption.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  selectOption: PropTypes.func.isRequired,
};

export default DropdownOption;
